export default __webpack_public_path__ + "b5ef31bc62286879a6b9214b3c5a801c.svg";